import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Button,
  CardMedia,
  Grid,
  Divider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PlaceholderImage from "@mui/icons-material/Image";
import { fetchStoryDetailsEditorial, deleteChapter } from "../utils/api";
import { useTheme } from "@mui/material/styles";
import ChapterListEditorial from "../components/ChapterListEditorial";

const StoryDetailsPageEditorial = () => {
  const { storyID } = useParams();
  const navigate = useNavigate();
  const [story, setStory] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    fetchStoryDetailsEditorial(storyID)
      .then((data) => {
        if (!data.coverImageUrl) {
          data.coverImageUrl = "https://fakeimg.pl/140x200?text=upload+a+cover&font=noto&font_size=16"; // Placeholder for missing image
        }
        setStory(data);
      })
      .catch(console.error);
  }, [storyID]);

  const handleDelete = (chapterIndex) => {
    deleteChapter(storyID, chapterIndex).then(() => {
      setStory((prev) => {
        const updatedChapters = { ...prev.chapters };
        delete updatedChapters[chapterIndex];
        return {
          ...prev,
          chapters: updatedChapters,
        };
      });
    });
  };

  const handleAddChapter = () => {
    const nextChapterIndex = story.chapters ? Object.keys(story.chapters).length + 1 : 1;
    navigate(`/editorial/stories/${storyID}/${nextChapterIndex}`);
  };
  

  if (!story)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );

  return (
    <Box
      sx={{
        maxWidth: 800,
        margin: "auto",
        padding: theme.spacing(3),
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          {story.coverImageUrl ? (
            <CardMedia
              component="img"
              image={story.coverImageUrl}
              alt="Story Cover"
              sx={{
                width: 140,
                height: 200,
                objectFit: "cover",
                borderRadius: theme.shape.borderRadius,
                boxShadow: theme.shadows[3],
              }}
            />
          ) : (
            <Box
              sx={{
                width: "100%",
                height: 200,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: theme.palette.grey[200],
                borderRadius: theme.shape.borderRadius,
                boxShadow: theme.shadows[3],
              }}
            >
              <PlaceholderImage sx={{ fontSize: 64, color: theme.palette.grey[500] }} />
            </Box>
          )}
        </Grid>

        <Grid item xs={8}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              textAlign: "left",
              marginBottom: theme.spacing(1),
            }}
          >
            {story.title}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ textAlign: "left", marginBottom: theme.spacing(2) }}
          >
            <strong>Author:</strong> {story.writerName || "Unknown"}
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ textAlign: "left" }}
          >
            {story.description || "No description available."}
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ marginY: theme.spacing(3) }} />

      <Box mt={3}>
        <ChapterListEditorial
          storyID={storyID}
          chapters={story.chapters}
          onDelete={handleDelete}
          isUGC={story.isUGC}
        />
      </Box>

      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        fullWidth
        sx={{ marginTop: theme.spacing(3) }}
        onClick={handleAddChapter}
      >
        Add New Chapter
      </Button>
    </Box>
  );
};

export default StoryDetailsPageEditorial;
